import type { ComponentProps } from 'react';

import { Link } from '@change-corgi/design-system/components/actions';
import { Box } from '@change-corgi/design-system/layout';
import { Heading, Text } from '@change-corgi/design-system/typography';

import { DecisionMakerResponseByLine } from './components/DecisionMakerResponseByLine';
import { DecisionMakerResponseMedia } from './components/DecisionMakerResponseMedia';
import { usePageHeading } from './hooks/usePageHeading';

export function PageHeading(props: ComponentProps<typeof Box>) {
	const {
		data: { title, type, petitionTitle, petitionUrl },
	} = usePageHeading();

	return (
		<Box {...props}>
			<Text size="small" fontWeight="bold" color="typography-secondary" data-qa="dm-response-type">
				{type}
			</Text>
			<Box pt={8}>
				<Link to={petitionUrl} data-qa="petition-title-link">
					{petitionTitle}
				</Link>
			</Box>
			<Heading size={['h2', 'h1']} data-qa="dm-response-title" mt={16} breakWord>
				{title}
			</Heading>
			<DecisionMakerResponseByLine mt={32} mb={32} />
			<DecisionMakerResponseMedia />
		</Box>
	);
}
